import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { FormInput } from "@/shared/ui/form-input"
import { yupResolver } from "@hookform/resolvers/yup"
import { SubmitHandler, useForm } from "react-hook-form"
import * as yup from "yup"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { format, parseISO } from "date-fns"
import {
    closeFillProfileModal,
    fetchFillUserProfile,
    selectFillProfileCurrentUser,
    selectFillProfileIsOpen,
    selectFillProfileOnSuccess
} from "../../model"

const schema = yup.object({
    name: yup.string().max(255).optional(),
    email: yup.string().email('Введите корректный email').max(255).optional(),
    date_of_birth: yup.date().nullable().optional(),
    gender: yup.string().oneOf(['male', 'female', '']).optional(),
})

type FormValues = yup.InferType<typeof schema>

const genderOptions = [
    { value: 'male', label: 'Мужской' },
    { value: 'female', label: 'Женский' },
]

export const FillProfileModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectFillProfileIsOpen)
    const currentUser = useAppSelector(selectFillProfileCurrentUser)
    const onSuccess = useAppSelector(selectFillProfileOnSuccess)

    const { register, handleSubmit, control, formState: { errors, isSubmitting }, reset } = useForm<FormValues>({
        resolver: yupResolver(schema),
        values: {
            name: currentUser?.name ?? '',
            email: currentUser?.email ?? '',
            date_of_birth: currentUser?.date_of_birth ? parseISO(currentUser.date_of_birth) : null,
            gender: currentUser?.gender ?? '',
        }
    })

    const handleClose = () => {
        dispatch(closeFillProfileModal())
        reset()
    }

    const onSubmit: SubmitHandler<FormValues> = async (data) => {
        await dispatch(fetchFillUserProfile({
            name: data.name || undefined,
            email: data.email || undefined,
            date_of_birth: data.date_of_birth ? format(data.date_of_birth, 'yyyy-MM-dd') : undefined,
            gender: (data.gender as 'male' | 'female') || undefined,
        }))
            .unwrap()
            .then(() => {
                notify.success('Профиль успешно обновлён')
                onSuccess?.()
                handleClose()
            })
            .catch((error) => {
                notify.error(getErrorMessage(error))
            })
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Заполнить профиль"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label="ФИО"
                    id="name"
                    required={false}
                    placeholder="Введите ФИО"
                    error={errors.name}
                />
                <FormInput
                    register={register}
                    label="Email"
                    id="email"
                    type="email"
                    required={false}
                    placeholder="Введите email"
                    error={errors.email}
                />
                <FormInput
                    label="Дата рождения"
                    id="date_of_birth"
                    type="datepicker"
                    control={control}
                    required={false}
                    placeholder="Выберите дату"
                    error={errors.date_of_birth as any}
                />
                <FormInput
                    label="Пол"
                    id="gender"
                    type="select"
                    control={control}
                    required={false}
                    placeholder="Выберите пол"
                    options={genderOptions}
                    error={errors.gender}
                />
                <div className="w-full flex gap-3 mt-2">
                    <button onClick={handleClose} type="button" className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>
    )
}
